import { Typography } from "@mui/material";

const AdjExtRetal = ({ rowData }: { rowData: any }) => {
  const value = rowData?.adjustedExtendedRetail;

  return (
    <Typography
      variant="subtitle2"
      color="grey.900"
      fontWeight={"normal"}
      sx={{ textTransform: "none", color: "grey.900" }}
    >
      {value || "$0.00"}
    </Typography>
  );
};

export default AdjExtRetal;
